import { Spinner } from 'flowbite-react';
import { motion, AnimatePresence } from 'framer-motion';

const Loading = () => {
   return (
      <AnimatePresence>
         <motion.div
            className="text-center flex items-center justify-center fixed bg-black/30 top-0 left-0 z-50 w-full h-full"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
         >
            <motion.div
               initial={{ scale: 0.8, opacity: 0 }}
               animate={{ scale: 1, opacity: 1 }}
               transition={{ 
                  duration: 0.4,
                  ease: "easeOut"
               }}
            >
               <Spinner color="gray" className="text-gray-400" />
            </motion.div>
         </motion.div>
      </AnimatePresence>
   );
}
export default Loading;
